// extracted by mini-css-extract-plugin
export var readyForEtrnBanner = "readyForEtrnBanner__jGq8";